import React, { useMemo } from 'react';
import { useLocation } from "react-router";
import TransactionsModal from "./TransactionsModal.jsx";
import SettingsModal from "./SettingsModal.jsx";
import { createStructuredSelector } from "reselect";
import { closeModalAction } from "../../app/appActions.js";
import { connect } from "react-redux";
import { makeSelectAppLoggedIn } from "../../app/appSelectors.js";
import WithdrawalRequestSentModal from "./WithdrawalRequestSentModal.jsx";
import { useResponsive } from "../../components/responsive";
import { Modal } from "react-bootstrap";
import IntroModal from '../Tutorials/IntroModal';
import ResetPasswordModal from "./ResetPasswordModal";
import { isClientMobile } from "../../components/ClientInfo/ClientInfo";
import RegisterEmailCheckModal from "./RegisterEmailCheckModal";
import EmailConfirmedModal from "./EmailConfirmedModal/EmailConfirmedModal";
import PartnerUpdatePostbackModal from "./PartnerUpdatePostbackModal";
import PartnerAddPostbackModal from "./PartnerAddPostbackModal";
import { getPartnerParams } from "../Partner/partnerSelectors";
import { MODALS_NAME } from "./modalsConstants";
import DepositSurveyModal from "./DepositSurveyModal";

export const MODALS_LOG_ACTION_TYPES = {
    OPEN: 'open',
    TAB: 'tab',
};

const Modals = (props) => {
    const {isSmallMaxWidth, isMediumMaxWidth} = useResponsive();
    const {
        loggedIn,
        closeModal,
        partnerParams,
    } = props;

    const {search} = useLocation();

    const [openedName, openedTab] = useMemo(() => {
        const params = new URLSearchParams(search);
        return [params.get('m'), params.get('tab')];
    }, [search]);

    return <>
        {
            openedName === MODALS_NAME.CASHIER && !isClientMobile && loggedIn &&
            <Modal show
                   onHide={closeModal}
                   backdrop={'static'}
                   centered
                   fullscreen={isMediumMaxWidth}
                   size={'xl'}>
                <TransactionsModal selectedItem={openedTab} closeModal={closeModal}/>
            </Modal>
        }
        {
            openedName === MODALS_NAME.PERSONAL && loggedIn &&
            <Modal show
                   onHide={closeModal}
                   centered
                   fullscreen={isSmallMaxWidth}>
                <SettingsModal closeModal={closeModal}/>
            </Modal>
        }
        {
            openedName === MODALS_NAME.WITHDRAWAL_REQUEST_SENT && loggedIn &&
            <Modal show
                   onHide={closeModal}
                   centered
                   fullscreen={isSmallMaxWidth}>
                <WithdrawalRequestSentModal closeModal={closeModal}/>
            </Modal>
        }
        {
            openedName === MODALS_NAME.INTRO && loggedIn &&
            <Modal show
                   onHide={closeModal}
                   centered
                   size={'xl'}
                   fullscreen={isSmallMaxWidth}>
                <IntroModal closeModal={closeModal}/>
            </Modal>
        }
        {
            openedName === MODALS_NAME.RESET_PASSWORD && loggedIn &&
            <Modal show
                   onHide={closeModal}
                   centered
                   fullscreen={isSmallMaxWidth}>
                <ResetPasswordModal closeModal={closeModal}/>
            </Modal>
        }
        {
            openedName === MODALS_NAME.REGISTER_EMAIL_CHECK && !loggedIn &&
            <Modal show
                   onHide={closeModal}
                   centered
                   fullscreen={isSmallMaxWidth}
                   contentClassName="pt-0"
            >
                <RegisterEmailCheckModal closeModal={closeModal}/>
            </Modal>
        }
        {
            openedName === MODALS_NAME.EMAIL_CONFIRMED && loggedIn &&
            <Modal show
                   onHide={closeModal}
                   centered
                   fullscreen={isSmallMaxWidth}
                   contentClassName="pt-0"
            >
                <EmailConfirmedModal closeModal={closeModal}/>
            </Modal>
        }
        {
            openedName === MODALS_NAME.PARTNER_ADD_POSTBACK && partnerParams.active &&
            <Modal show
                   onHide={closeModal}
                   centered
                   fullscreen={isSmallMaxWidth}
            >
                <PartnerAddPostbackModal/>
            </Modal>
        }
        {
            openedName === MODALS_NAME.PARTNER_UPDATE_POSTBACK && partnerParams.active &&
            <Modal show
                   onHide={closeModal}
                   centered
                   fullscreen={isSmallMaxWidth}
            >
                <PartnerUpdatePostbackModal/>
            </Modal>
        }
        {
            openedName === MODALS_NAME.DEPOSIT_SURVEY && loggedIn &&
            <Modal show
                   onHide={closeModal}
                   centered
                   fullscreen={isSmallMaxWidth}
            >
                <DepositSurveyModal/>
            </Modal>
        }
    </>;
};

const mapStateToProps = createStructuredSelector({
    loggedIn: makeSelectAppLoggedIn(),
    partnerParams: getPartnerParams,
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: (payload) => dispatch(closeModalAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modals);

